<!-- Spacer -->
<div
    class="red-vertical-navigation-item-wrapper"
    [ngClass]="item.classes?.wrapper!"></div>
